import { kManualMargins, kMasterSCID } from "../constants";
import { QSCNode } from "./QSCNode";
import { QBackgroundArea } from "./QBackgroundArea";

export class QActiveBackground {
  constructor() {
    this.name = null;
    this.pageProps = null;
    this.areas = {};
    this.currentElementFocus = false;
  }

  InitActiveBackground(backgroundMgr) {
    this.fBackgroundMgr = backgroundMgr;
  }

  SetAreas(areas) {
    this.areas = areas;
  }

  GetAreas() {
    return this.areas;
  }

  SetPageProps(pp) {
    this.pageProps = pp;
  }

  GetPageProps() {
    return this.pageProps;
  }

  Clone() {
    var c = new QActiveBackground();
    c.name = this.name;
    c.pageProps = this.pageProps;
    for (const [key, area] of Object.entries(this.areas)) {
      c.areas[key] = area.Clone();
    }
    return c;
  }

  LoadFromJSON(json) {
    if (!json["areas"]) return;

    for (var [key, area] of Object.entries(json["areas"])) {
      var backgroundArea = new QBackgroundArea();
      backgroundArea.InitBackgroundArea();
      backgroundArea.LoadFromJSON(area);
      this.areas[key] = backgroundArea;
    }
  }

  OutputToJSON() {
    var jsonBackground = { areas: {} };
    if (!this.areas) return jsonBackground;

    for (const [key, area] of Object.entries(this.areas)) {
      jsonBackground["areas"][key] = area.OutputToJSON();
    }
    return jsonBackground;
  }

  GetUID() {
    return this.fBackgroundMgr.GetUID();
  }

  AssignUIDs() {
    var areas = this.areas;
    if (!areas) return;
    var baseId = this.GetUID();
    for (const [key, area] of Object.entries(this.areas)) {
      var layouts = area.GetLayouts();
      for (var layout of layouts) {
        var nextID = baseId++;
        layout.SetDBObjID(nextID);
      }
    }
  }

  GetBackgroundNodes() {
    this.AssignUIDs();
    var backgroundAreas = this.GetAreas();
    if (!backgroundAreas) return [];
    var layouts = this.GetProcessedLayoutList(backgroundAreas);
    return this.BuildNodesFromLayouts(layouts);
  }

  GainElementFocus(clearPrior = true) {
    if (this.currentElementFocus) {
      var { area, layoutIndex } = this.currentElementFocus;
      var areas = this.GetAreas();
      var targetArea = areas[area];
      if (!targetArea) return;
      var layouts = targetArea.GetLayouts();
      var focusElement = layouts[layoutIndex];
      if (focusElement) {
        this.fBackgroundMgr.SelectBackgroundElement(focusElement.GetDBObjID(), clearPrior);
        this.currentElementFocus = null;
      }
    }
  }

  BuildNodesFromLayouts(processedLayouts) {
    var wsMgr = this.GetWSMgr();
    var scm = wsMgr?.GetSubChartMgr();
    var nodes = [];
    for (var layout of processedLayouts) {
      var clonedLayout = layout.Clone({ includeId: true });
      var newNode = new QSCNode();
      newNode.InitSCNode(clonedLayout, null, clonedLayout.GetDBObjID(), scm);
      nodes.push(newNode);
    }
    return nodes;
  }

  GetProcessedLayoutList(areas) {
    let processedLayouts = [];
    for (const [key, area] of Object.entries(areas)) {
      var doAutoPlacement = key !== "customPlacement";
      var areaLayouts = doAutoPlacement ? this.ApplyLayoutSpacing(area, key) : area?.GetLayouts();
      processedLayouts = processedLayouts.concat(...areaLayouts);
    }
    return processedLayouts;
  }

  ApplyLayoutSpacing(areaObj, key) {
    var layouts = areaObj?.GetLayouts();
    var adjustedLayouts = [];
    if (!layouts) return adjustedLayouts;
    var spacingOffset = 0;
    var isBottomArea = key.includes("bottom");
    var spaceKey = isBottomArea ? "fBottom" : "fTop";
    for (var i = 0; i < layouts.length; i++) {
      var layout = layouts[i];

      var newLayout = layout.Clone({ includeId: true });
      var userSpacing = newLayout.GetBoxMargins();
      var spacingStart = userSpacing.Clone();

      layout.fCachedHeight = null;

      if (isBottomArea) {
        spacingStart.fBottom += spacingOffset;
      } else {
        spacingStart.fTop += spacingOffset;
      }

      newLayout.SetBoxSpacing(spacingStart);

      var layoutRect = layout.PGetBoundingRect();
      var totalHeight = layoutRect.fBottom - layoutRect.fTop;

      spacingOffset += totalHeight + userSpacing[spaceKey];

      adjustedLayouts.push(newLayout);
    }
    return adjustedLayouts;
  }

  SyncAreasWithDoc(doc) {
    var areas = this.GetAreas();
    if (!areas) return;
    for (const [key, area] of Object.entries(areas)) {
      var layouts = area.GetLayouts();
      var syncedLayouts = [];
      for (var layout of layouts) {
        var syncedLayout = layout.Clone({ includeId: true });
        if (syncedLayout.GetMarginMode() !== kManualMargins)
          syncedLayout.SetDefaultBackgroundMargins();
        syncedLayout.SetSubChartID(kMasterSCID);
        doc.FinishLoadLayout(syncedLayout);
        syncedLayouts.push(syncedLayout);
      }
      area.SetLayouts(syncedLayouts);
      this.areas[key] = area;
    }
  }

  GetWSMgr() {
    var backgroundMgr = this.fBackgroundMgr;
    return backgroundMgr?.fWSMgr;
  }
}
